export const trendingBoard = [
  {
    rank: 1,
    title: "招股书三版口径对比，脚注里写了什么",
    tag: "商业观察",
    heat: 9820,
    trend: "up",
    stat: "阅读 12.4 万 · 讨论 862",
  },
  {
    rank: 2,
    title: "直播翻车当晚的库存改动记录",
    tag: "舆情复盘",
    heat: 9410,
    trend: "up",
    stat: "阅读 9.8 万 · 讨论 704",
  },
  {
    rank: 3,
    title: "那 17 分钟：三个来源的时间线对撞",
    tag: "细节考据",
    heat: 8765,
    trend: "flat",
    stat: "阅读 8.1 万 · 讨论 611",
  },
  {
    rank: 4,
    title: "同期下架的三款产品做对了什么",
    tag: "行业脉络",
    heat: 7420,
    trend: "up",
    stat: "阅读 6.3 万 · 讨论 428",
  },
  {
    rank: 5,
    title: "被当成证据的表情包，是怎么来的",
    tag: "细节考据",
    heat: 6310,
    trend: "down",
    stat: "阅读 5.2 万 · 讨论 356",
  },
  {
    rank: 6,
    title: "同一事实，两套标准：争议为什么会跑偏",
    tag: "观点拆解",
    heat: 5980,
    trend: "flat",
    stat: "阅读 4.7 万 · 讨论 512",
  },
];

export const trendingTags = [
  "舆情复盘",
  "细节考据",
  "商业观察",
  "观点拆解",
  "行业脉络",
  "时间线对撞",
];